/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Membership_Confirmations_Member_RejectedInputs */

const en_admin_membership_confirmations_member_rejected = /** @type {(inputs: Admin_Membership_Confirmations_Member_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The member was rejected and all connected data deleted.`)
};

const nl_admin_membership_confirmations_member_rejected = /** @type {(inputs: Admin_Membership_Confirmations_Member_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het lid is afgewezen en alle gekoppelde gegevens zijn verwijderd.`)
};

/** @type {(inputs: Admin_Membership_Confirmations_Member_RejectedInputs) => LocalizedString} */
const de_admin_membership_confirmations_member_rejected = en_admin_membership_confirmations_member_rejected;

/** @type {(inputs: Admin_Membership_Confirmations_Member_RejectedInputs) => LocalizedString} */
const es_admin_membership_confirmations_member_rejected = en_admin_membership_confirmations_member_rejected;

/** @type {(inputs: Admin_Membership_Confirmations_Member_RejectedInputs) => LocalizedString} */
const fr_admin_membership_confirmations_member_rejected = en_admin_membership_confirmations_member_rejected;

/** @type {(inputs: Admin_Membership_Confirmations_Member_RejectedInputs) => LocalizedString} */
const it_admin_membership_confirmations_member_rejected = en_admin_membership_confirmations_member_rejected;

/** @type {(inputs: Admin_Membership_Confirmations_Member_RejectedInputs) => LocalizedString} */
const pt_br2_admin_membership_confirmations_member_rejected = en_admin_membership_confirmations_member_rejected;

/** @type {(inputs: Admin_Membership_Confirmations_Member_RejectedInputs) => LocalizedString} */
const pl_admin_membership_confirmations_member_rejected = en_admin_membership_confirmations_member_rejected;

/** @type {(inputs: Admin_Membership_Confirmations_Member_RejectedInputs) => LocalizedString} */
const hu_admin_membership_confirmations_member_rejected = en_admin_membership_confirmations_member_rejected;

/** @type {(inputs: Admin_Membership_Confirmations_Member_RejectedInputs) => LocalizedString} */
const ro_admin_membership_confirmations_member_rejected = en_admin_membership_confirmations_member_rejected;

/**
* | output |
* | --- |
* | "The member was rejected and all connected data deleted." |
*
* @param {Admin_Membership_Confirmations_Member_RejectedInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_membership_confirmations_member_rejected = /** @type {((inputs?: Admin_Membership_Confirmations_Member_RejectedInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Membership_Confirmations_Member_RejectedInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_membership_confirmations_member_rejected(inputs)
	if (locale === "de") return de_admin_membership_confirmations_member_rejected(inputs)
	if (locale === "es") return es_admin_membership_confirmations_member_rejected(inputs)
	if (locale === "fr") return fr_admin_membership_confirmations_member_rejected(inputs)
	if (locale === "nl") return nl_admin_membership_confirmations_member_rejected(inputs)
	if (locale === "it") return it_admin_membership_confirmations_member_rejected(inputs)
	if (locale === "pt-BR") return pt_br2_admin_membership_confirmations_member_rejected(inputs)
	if (locale === "pl") return pl_admin_membership_confirmations_member_rejected(inputs)
	if (locale === "hu") return hu_admin_membership_confirmations_member_rejected(inputs)
	return ro_admin_membership_confirmations_member_rejected(inputs)
});
export { admin_membership_confirmations_member_rejected as "admin.membership_confirmations.member_rejected" }